/**
 * Map tickets / tours → GA4 ecommerce items
 */

export function parseMoney(value) {
    if (typeof value === "number" && Number.isFinite(value)) {
        return value;
    }
    if (value == null || value === "") {
        return 0;
    }
    const cleaned = String(value)
        .replace(/[^\d.,-]/g, "")
        .replace(/,/g, "");
    const n = Number(cleaned);
    return Number.isFinite(n) ? n : 0;
}

export function resolveCurrency(raw) {
    if (!raw) return "USD";
    const s = String(raw).toUpperCase();
    if (s === "BRL" || s === "R$" || s.includes("R$")) return "BRL";
    if (s === "USD" || s === "US$" || s.includes("US$")) return "USD";
    if (s.length === 3) return s;
    return "USD";
}

/**
 * @param {object} ticket
 * @param {object} [opts]
 */
export function ticketToItem(ticket, opts = {}) {
    if (!ticket) return null;

    const quantity = opts.quantity != null ? Number(opts.quantity) || 1 : 1;
    const price =
        opts.price != null
            ? parseMoney(opts.price)
            : parseMoney(
                  ticket.price_ref != null && typeof ticket.price_ref === "number"
                      ? ticket.price_ref
                      : ticket.price
              );

    const name =
        ticket.title ||
        ticket.description ||
        ticket.location ||
        [ticket.location_slug || ticket.type, ticket.sector]
            .filter(Boolean)
            .join(" · ") ||
        "Ticket";

    const category =
        ticket.location_slug ||
        ticket.type ||
        ticket.location ||
        ticket.item_category ||
        "ticket";

    return {
        item_id: String(ticket.sku_id || ticket.id || ""),
        item_name: String(name),
        item_category: String(category),
        item_variant: ticket.sector != null ? String(ticket.sector) : undefined,
        price,
        quantity
    };
}

/**
 * @param {object} tour
 * @param {object} [opts]
 */
export function tourToItem(tour, opts = {}) {
    if (!tour) return null;

    const quantity = opts.quantity != null ? Number(opts.quantity) || 1 : 1;
    const price = opts.price != null ? parseMoney(opts.price) : parseMoney(tour.price);

    return {
        item_id: String(
            tour.sku_id || tour.wc_tour_id || tour.id || tour.name || "tour"
        ),
        item_name: String(tour.name || tour.title || "Tour"),
        item_category: "tour",
        price,
        quantity
    };
}

export function sumItemsValue(items) {
    if (!Array.isArray(items)) return 0;
    return items.reduce(
        (sum, item) => sum + (Number(item.price) || 0) * (Number(item.quantity) || 1),
        0
    );
}

/**
 * Flatten tickets-table nested structure → array of ticket objects
 */
export function flattenTickets(tickets) {
    if (!tickets) return [];
    if (Array.isArray(tickets)) return tickets.filter(Boolean);

    const out = [];
    Object.keys(tickets).forEach(key => {
        const group = tickets[key];
        if (Array.isArray(group)) {
            group.forEach(t => t && out.push(t));
        } else if (group && typeof group === "object") {
            Object.keys(group).forEach(k2 => {
                const row = group[k2];
                if (Array.isArray(row)) {
                    row.forEach(t => t && out.push(t));
                } else if (row && typeof row === "object" && (row.id || row.sku_id)) {
                    out.push(row);
                }
            });
        }
    });
    return out;
}
